export default __webpack_public_path__ + "static/thebottomline29-24b471b62a2914846e14e5eadf688ff8.jpg";